export default __webpack_public_path__ + "a8f04ab.png";